const InfoAlert = () => {
    return null;
}

export default InfoAlert;